import { io, Socket } from 'socket.io-client';
import { Store } from 'vuex';
import AppConstants from '../model/AppConstants';
import DatasetMultipleValue from '../model/realtime/DatasetMultipleUpdate';
import DatasetUpdate from '../model/realtime/DatasetUpdate';
import Actions from '../model/store/actions';
import State from '../model/store/state';

/* eslint-disable @typescript-eslint/no-var-requires, no-var */

export default class Realtime {
  socket: Socket;

  private static instance: Realtime;

  private constructor(private store: Store<State>) {
    this.socket = io(process.env.VUE_APP_REALTIME_URI, {
      autoConnect: false,
      path: process.env.VUE_APP_REALTIME_PATH,
    });
    this.socket.on('connect', this.connect.bind(this));
    this.socket.on('disconnect', this.disconnect.bind(this));
    this.socket.on('reconnect', this.reload.bind(this));
    this.socket.on('reload', this.reload.bind(this));
    this.socket.on('dataset:update', this.datasetUpdate.bind(this));
    this.socket.on('dataset:multiple-update', this.datasetMultipleUpdate.bind(this));
  }

  public static getInstance(store?: Store<State>): Realtime {
    if (!Realtime.instance) {
      if (!store) throw new Error('Store is required for Realtime instance creation');
      Realtime.instance = new Realtime(store);
    }
    return Realtime.instance;
  }

  init() {
    this.socket.connect();
  }

  /**
   * Mise à jour d'une valeur de ds par le serveur
   * @param update Mise à jour d'une valeur
   * Attention: update.dataset représente le nom réel (RD) du dataset
   */
  datasetUpdate(update: DatasetUpdate) {
    // Pour chaque ds référencé ayant pour nom RD celui de l'update : mise à jour
    // eslint-disable-next-line no-console
    console.debug('Realtime.datasetUpdate', update);
    Object.keys(this.store.state.datasets).forEach((datasetAlias) => {
      const values = this.store.getters.all(datasetAlias);
      if (values.$dataset_name === update.dataset)
        this.store.dispatch(Actions.DATASET_SET, {
          name: datasetAlias,
          key: update.key,
          value: update.value,
        });
    });
  }

  /**
   * Mise à jour de valeurs de ds par le serveur
   * @param multipleUpdate Mise à jour de plusieurs valeurs
   * Attention: multipleUpdate.dataset représente le nom réel (RD) du dataset
   */
  datasetMultipleUpdate(multipleUpdate: DatasetMultipleValue) {
    // Pour chaque ds référencé ayant pour nom RD celui de l'update : mise à jour
    // eslint-disable-next-line no-console
    console.debug('Realtime.datasetMultipleUpdate', multipleUpdate);
    const keys = Object.keys(multipleUpdate.values);
    if (keys.length) {
      Object.keys(this.store.state.datasets).forEach((datasetAlias) => {
        const values = this.store.getters.all(datasetAlias);
        if (values.$dataset_name === multipleUpdate.dataset) {
          this.store.dispatch(Actions.DATASET_SET_MULTIPLE, {
            name: datasetAlias,
            values: multipleUpdate.values,
          });
        }
      });
    }
  }

  connect() {
    this.store.dispatch(Actions.DATASET_SET, {
      name: AppConstants.APP_DATASET_NAME,
      key: 'online',
      value: true,
    });
    this.register();
  }

  disconnect() {
    this.store.dispatch(Actions.DATASET_SET, {
      name: AppConstants.APP_DATASET_NAME,
      key: 'online',
      value: false,
    });
  }

  reload() {
    window.location.reload();
  }

  /**
   * Permet de s'enregistrer auprès du serveur comme utilisateur d'un dataset et ainsi en recevoir les mises à jour
   */
  register() {
    const registerTo = new Set<string>();
    // Parcours des datasets utilisés pour récupérer les noms RD
    Object.keys(this.store.state.datasets).forEach((alias: string) => {
      const realName = this.store.getters.value(alias, '$dataset_name');
      if (realName) registerTo.add(realName);
    });
    // Enregistrement
    if (this.socket.connected) {
      this.socket.emit('register', Array.from(registerTo));
      this.socket.emit('info', {
        uuid: localStorage.uuid,
        // site: this.appConfiguration.lastSiteAndPage.site,
        // page: this.appConfiguration.lastSiteAndPage.page,
        site: '#',
        page: '##',
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
  }

  subscribeToDatasets(datasetsAndAliases: { name: string; alias: string }[]) {
    datasetsAndAliases.forEach((datasetAndAlias) => {
      this.socket.emit('register', [datasetAndAlias.name]);
      this.store.dispatch(Actions.DATASET_SET, {
        name: datasetAndAlias.alias,
        key: AppConstants.DATASET_REAL_NAME_KEY,
        value: datasetAndAlias.name,
      });
    });
  }
}
